// Define gtag type for better type safety
interface GtagFunction {
    (command: 'event', eventName: string, eventParams?: Record<string, unknown>): void;
}

declare global {
    interface Window {
        gtag?: GtagFunction;
    }
}

export const trackEvent = (eventName: string, eventParams?: Record<string, unknown>) => {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
        window.gtag('event', eventName, eventParams);
    }
};
